import React from "react";
import styled, { css } from "styled-components";

const StyledIcon = styled.svg`
  ${({ ...props }) => css`
    color: ${props.theme.colors.primary};
  `}
`;

function StarIcon() {
  return (
    <StyledIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero" className="cat-fill">
          <path d="M10.713.835L7.783 7.04 1.23 8.04C.054 8.217-.417 9.73.435 10.598l4.742 4.827-1.122 6.82c-.202 1.232 1.041 2.156 2.082 1.58L12 20.604l5.863 3.22c1.04.571 2.284-.348 2.082-1.58l-1.122-6.82 4.742-4.827c.852-.867.381-2.381-.794-2.56l-6.554-.998-2.93-6.205a1.41 1.41 0 00-2.574 0z"></path>
        </g>
      </g>
    </StyledIcon>
  );
}

export default StarIcon;
